import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MatSnackBarRef, MAT_SNACK_BAR_DATA }
	from '@angular/material/snack-bar';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';

@Component({
	selector: 'copo-snackbar-delete-draft',
	templateUrl: './snackbar-delete-draft.component.html',
	encapsulation: ViewEncapsulation.Emulated,

	imports: [MatButtonModule, TranslateModule]
})
export class SnackbarDeleteDraftComponent {
	constructor(
		private readonly snackBarRef: MatSnackBarRef<SnackbarDeleteDraftComponent>,
		@Inject(MAT_SNACK_BAR_DATA) public data: string
	) {}

	dismiss() {
		this.snackBarRef.dismiss();
	}

	getData() {
		return this.data;
	}
}
